import { jwtDecode } from 'jwt-decode';
import AccessToken from './access-token.model';

export default class Jwt {
  token;
  username;
  firstName;
  lastName;
  uuid;
  accessToken;
  email;
  status;
  expiresAt;
  issuedAt;

  constructor(token) {
    if (!token) {
      throw new Error('A JWT token is required');
    }
    const decodedJwt = Jwt.decode(token);

    this.token = token;
    this.username = decodedJwt.sub;
    this.firstName = decodedJwt.firstName;
    this.lastName = decodedJwt.lastName;
    this.uuid = decodedJwt.uuid;
    this.accessToken = decodedJwt.api_token ? new AccessToken(decodedJwt.api_token, 'production') : null;
    this.email = decodedJwt.email;
    this.status = decodedJwt.status;

    this.expiresAt = new Date(decodedJwt.exp * 1000);
    this.issuedAt = new Date(decodedJwt.iat * 1000);
  }

  static decode(jwt) {
    let decodedJwt;
    try {
      decodedJwt = jwt ? jwtDecode(jwt) : null;
      if (!decodedJwt) {
        throw new Error('Failed to decode JWT');
      }
    } catch (error) {
      throw new Error(`JWT decode failed: ${error.message}`);
    }
    return decodedJwt;
  }

  get hasAccessToken() {
    return !!this.accessToken;
  }
}
